import { render } from "./DashbordIndex2.vue?vue&type=template&id=6fdbffed"
import script from "./DashbordIndex2.vue?vue&type=script&lang=js"
export * from "./DashbordIndex2.vue?vue&type=script&lang=js"

import "./DashbordIndex2.vue?vue&type=style&index=0&id=6fdbffed&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__